import React from "react";
import { IntegrationTitle } from "../integrationsOnboarding/IntegrationTitle";
import { IntegrationSections } from "../integrationsOnboarding/IntegrationSections";
import { localizedStrings } from 'src/localization/index.jsx';

export const SalesforceSandboxOnboardingView = ({selectedTab, disableScroll}) => {

    const integration = localizedStrings.constants.integrationsOnboarding.integrations.salesforce;
    const sections = integration.sections;

    return (
        <div>
            <IntegrationTitle title={integration.title} />
            <IntegrationSections sections={sections} tab={selectedTab} disableScroll={disableScroll}/>
        </div>
    )
}